import { render } from "./EmployeeManagement.vue?vue&type=template&id=3b272a36"
import script from "./EmployeeManagement.vue?vue&type=script&lang=js"
export * from "./EmployeeManagement.vue?vue&type=script&lang=js"

import "./EmployeeManagement.vue?vue&type=style&index=0&id=3b272a36&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__